export default __webpack_public_path__ + "static/media/track-shipment-2.bb0231f4.svg";